
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/collocations-explanation';
const mainimage = '/Images/collocations1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "collocations" },
];

const Collocations = () => (
  <GrammarPageLayout
    level="B2"
    title="Collocations"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Collocations Exercises"
    seoDescription="Master natural word combinations that native speakers use daily. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Collocations;

